import React, { useMemo, useEffect, useState, memo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Listjson from "../helplist/listData.json";
import ContentLoader from "react-content-loader";
import Parser from "html-react-parser";
import serverPath from ".././serverpath.js";

const PlusSearch = memo((props) => {
	const location = useLocation();
	const navigate = useNavigate();
	const mysearch = location.state ? location.state.mysearch : null;
	const topdiv = useRef();

	const [expv, setExpv] = useState([]);
	const [contentLoader, setloader] = useState(true);
	// var contentLoader = true;
	// console.log(expv, expv.length, contentLoader);
	let nftoken;
	let realtoken;

	const tokensText = async (searchtext) => {
		// console.log("search call");
		// const searchTermRegex = new RegExp(realtoken.join("|"), "gim");
		const realtoken = searchtext
			.toLowerCase()
			.split(" ")
			.filter((token) => {
				return token.trim() !== "";
			});
		// console.log(realtoken);

		let datarender = [];
		// console.log("inner----", datarender);
		let wordArrObj = [];

		// let maploop = 0;
		// let notfoundtoken = [];

		const searchbase = async () => {
			// sessionStorage.clear();
			const htmltotext = async (htmlobj) => {
				const htmldoc = await (await fetch(`/_WHTML/${htmlobj.file}.html`)).text();
				let parser = new DOMParser();
				let dom_document = parser.parseFromString(htmldoc, "text/html");
				let body_element = dom_document.getElementsByTagName("body")[0];
				// allTxet is now in nodeList form like a array but not array
				const allText = body_element.getElementsByTagName("*");
				// console.log("at", Array.isArray(allText));
				const elearray = Array.from(allText); // convert to array with from() and then use any iterate method
				// console.log( Array.isArray(elearray));
				const elearrtext = elearray.map((ele) => {
					return ele.textContent;
				});
				const myStringWithCustomSeparator = elearrtext.join(" ");
				// console.log("-=-=-=-=-=-", typeof myStringWithCustomSeparator);
				return new Promise((resolve) => {
					resolve({ listobj: JSON.parse(JSON.stringify(htmlobj)), filetext: myStringWithCustomSeparator }); // this is remove reference to original json
				});
			};

			const dytoText = async (child) => {
				// console.log(`${serverPath.dypath}/transit`);
				return await fetch(serverPath.dypath ? `${serverPath.dypath}transit`: "/transit", {
					// Adding method type
					method: "POST",
					// Adding body or contents to send
					body: JSON.stringify({
						path: child.nodepath,
					}),
					// Adding headers to the request
					headers: {
						"Content-type": "application/json; charset=UTF-8",
					},
				})
					.then((response) => {
						// console.log("resp", response);
						return response.json();
					})
					.then((jsonData) => {
						// console.log(jsonData);
						function getAllValues(obj) {
							const values = [];
							// Helper function to traverse nested structures recursively
							function traverse(item, extra) {
								// console.log("112334455", values);
								if (Array.isArray(item)) {
									// If it's an array, recursively call traverse on each element
									// item.forEach(traverse);
									item.forEach((arr) => {
										traverse(arr, extra);
									});
								} else if (item && typeof item === "object") {
									// If it's an object, recursively call traverse on each value
									Object.keys(item).forEach((key) => {
										if (key === "section-heading") {
											values.push({ [key]: item[key] }); // Add
										} else if (key === "section-heading-desc") {
											values[0][key] = item[key];
										} else if (key === "sub-section-link") {
											values[0][key] = item[key];
										} else if (key === "sub-section") {
											if (!values[0].hasOwnProperty("sub-section-arr")) {
												values[0]["sub-section-arr"] = [];
											}
											values[0]["sub-section-arr"].push({ ssubsec: item[key] });
										} else if (key === "sub-section-desc") {
											values[0]["sub-section-arr"][values[0]["sub-section-arr"].length - 1]["ssubsecdesc"] = item[key];
										} else if (key === "hash-link-id") {
											values[0]["sub-section-arr"][values[0]["sub-section-arr"].length - 1]["ssubsechashid"] = item[key];
										} else if (key === "sub-section-step") {
											traverse(item[key], [item["sub-section"], item["hash-link-id"]]);
										} else if (key === "step-desc") {
											// console.log("5r4345gvhbjfd78868df789gdg", item[key]);
											traverse(item[key], [...extra, item["step-no"]]);
										} else if (key === "note-title") {
											traverse(`${item[key]} -- ${item["note-desc"]}`, [...extra, "note"]);
										}
									});
								} else {
									// If it's neither an array nor an object, it's a value
									if (extra.length === 3) {
										if (values[0].hasOwnProperty("sub-section-arr") && !values[0]["sub-section-arr"][values[0]["sub-section-arr"].length - 1].hasOwnProperty("ssubsecstepdata")) {
											values[0]["sub-section-arr"][values[0]["sub-section-arr"].length - 1]["ssubsecstepdata"] = [];
										}

										values[0]["sub-section-arr"][values[0]["sub-section-arr"].length - 1]["ssubsecstepdata"].push({ sstepdata: item, ssubsec: extra[0], ssubsechashid: extra[1], sstepno: extra[2] });
									}
								}
							}

							// Start the traversal from the initial object
							traverse(obj);

							// const singleString = values.join(" ");
							// console.log({ listobj: JSON.parse(JSON.stringify(child)), filetext: singleString });
							return { listobj: JSON.parse(JSON.stringify(child)), hyperjsontext: { ...values[0] } };
						}
						return getAllValues(jsonData);
					})
					.catch((error) => {
						// const boxerr = { msg: "Technical Error - fail to fetch data" };
						console.warn(error, child.name, "fetch failed");
						// navigate(-1);
						// navprocess(boxerr);
					});
			};

			const baseMaker = async () => {
				for (const accordObj of Listjson) {
					if (accordObj?.child && accordObj?.child.length !== 0) {
						for (const child of accordObj.child) {
							if (child.nodepath) {
								const dytext = await dytoText(child);
								// console.log("here is the nodePath", dytext);
								wordArrObj.push(dytext);
							} else if (child.file) {
								const childbaseObj = await htmltotext(child);
								// console.log(Array.isArray(childbaseObj));
								wordArrObj.push(childbaseObj);
								// console.log("mapping going", wordArrObj.length, wordArrObj);
							}
						}
					}
				}

				return wordArrObj;
			};
			// await baseMaker();

			let sessionbase = JSON.parse(sessionStorage.getItem("ssbase")); //ssbase means 'session search base'
			// console.log(sessionbase);
			if (!sessionbase) {
				await baseMaker().then((data) => {
					console.log(Array.isArray(data));
					sessionStorage.setItem("ssbase", JSON.stringify(data));
					sessionbase = data;
					// wordArrObj1 = [...wordArrObj];
				}).catch(() => {
					console.warn("session ssbase ERROR !!!!!!!");
				});
			} else {
				// sessionStorage.clear();
				// console.log('session else - get ssdata');
				// wordArrObj1 = sessionStorage.getItem("ssbase");
			}

			// console.log(wordArrObj);
			const result = () => {
				for (const baseobj of sessionbase) {
					let childbase = JSON.parse(JSON.stringify(baseobj));
					if (childbase?.filetext) {
						const textfield = childbase?.filetext;
						const regex = new RegExp(realtoken.join("|"), "gim");
						if (regex.test(textfield)) {
							if (childbase?.listobj?.name) {
								const stokenregex = new RegExp(realtoken.join("|"), "gim");
								const matchwordhead = childbase.listobj.name.match(stokenregex);
								// let markheadname = editlistobj.name;
								if (matchwordhead) {
									const uniQheadmatch = [...new Set(matchwordhead)];
									uniQheadmatch.map((word) => {
										const markreg = new RegExp(word, "g");
										childbase.listobj.name = childbase.listobj.name.replace(markreg, "<mark>" + word + "</mark>");
										if (childbase?.listobj?.search?.prior >= 0) {
											childbase.listobj.search.prior += matchwordhead.length * 5;
										} else {
											console.warn("incomplete format");
										}
									});
								}
							}
							if (childbase?.listobj?.search?.desc) {
								const stokenregex = new RegExp(realtoken.join("|"), "gim");
								const matchworddesc = childbase.listobj.search.desc.match(stokenregex);
								// let markworddesc = editlistobj.search.desc;
								if (matchworddesc) {
									const uniQdescmatch = [...new Set(matchworddesc)];
									uniQdescmatch.map((word) => {
										const markreg = new RegExp(word, "g");
										childbase.listobj.search.desc = childbase.listobj.search.desc.replace(markreg, "<mark>" + word + "</mark>");
										if (childbase?.listobj?.search?.prior >= 0) {
											childbase.listobj.search.prior += matchworddesc.length * 2;
										} else {
											console.warn("incomplete format");
										}
									});
								}
							}

							const con = datarender.every((rend) => {
								return rend.id !== childbase.listobj.id;
							});
							if (con) {
								datarender.push(JSON.parse(JSON.stringify(childbase.listobj))); // this is remove reference to original json
							} else {
								// this block will not execute because search tokens mapping is eliminated
								const objindex = datarender.findIndex((obj) => obj.id === childbase.listobj.id);
								if ("search" in datarender[objindex] && "prior" in datarender[objindex].search) {
									datarender[objindex].search.prior += 1;
								} else {
									// console.log("word match but JSON", childbase.listobj.name);
								}
							}
						}
					} else if (childbase?.hyperjsontext) {
						const stokenregex = new RegExp(realtoken.join("|"), "gim");
						if (stokenregex.test(childbase.hyperjsontext?.["section-heading"]) || stokenregex.test(childbase.hyperjsontext?.["section-heading-desc"])) {
							const matcheSecHead = childbase.hyperjsontext["section-heading"].match(stokenregex);
							const matcheSecdesc = childbase.hyperjsontext["section-heading-desc"].join(" ").match(stokenregex);

							let marksecdata = childbase.hyperjsontext["section-heading"];
							if (matcheSecHead) {
								const uniQheadmatch = [...new Set(matcheSecHead)];
								uniQheadmatch.map((word) => {
									const markreg = new RegExp(word, "g");
									marksecdata = marksecdata.replace(markreg, "<mark>" + word + "</mark>");
								});
							}

							let marksecdescdata = childbase.hyperjsontext["section-heading-desc"].join(" @@ ");
							if (matcheSecdesc) {
								const uniQheaddescmatch = [...new Set(matcheSecdesc)];
								uniQheaddescmatch.map((word) => {
									const markreg = new RegExp(word, "g");
									marksecdescdata = marksecdescdata.replace(markreg, "<mark>" + word + "</mark>");
								});
							}
							// console.log(matcheSecdesc, "----", uniQmatch);
							const checkprior = datarender.every((rend) => {
								return rend.id !== childbase.listobj.id;
							});
							if (checkprior) {
								datarender.push({ ...JSON.parse(JSON.stringify(childbase.listobj)) });
								datarender[datarender.length - 1].search.sdisplay = { dasechead: marksecdata, dasecdesc: marksecdescdata.split(" @@ ") };
								if (matcheSecHead && datarender[datarender.length - 1]) {
									if (childbase.hyperjsontext["section-heading"].split(" ").length === matcheSecHead.length || (childbase.hyperjsontext["section-heading"].split(" ").length > 2 && childbase.hyperjsontext["section-heading"].split(" ").length === matcheSecHead.length - 1)) {
										datarender[datarender.length - 1].search.prior += matcheSecHead.length * 50;
									} else {
										datarender[datarender.length - 1].search.prior += matcheSecHead.length * 10;
										// datarender[datarender.length - 1].search.prior += matchsubsec.length * 5;
									}
								}
								if (matcheSecdesc && datarender[datarender.length - 1]) {
									datarender[datarender.length - 1].search.prior += matcheSecdesc.length * 2;
								}
							} else {
								// const objindex = datarender.findIndex((obj) => obj.id === childbase.listobj.id);
								// datarender[objindex].search.sdisplay.sechead = datarender[objindex].search.sdisplay.sechead;
								// datarender[objindex].search.prior += 2;
								console.warn("repeat in top section title");
							}
						}
						if (childbase?.hyperjsontext?.["sub-section-arr"]) {
							for (const ss of childbase?.hyperjsontext?.["sub-section-arr"]) {
								if (stokenregex.test(ss.ssubsec)) {
									const matchsubsec = ss.ssubsec.match(stokenregex);
									let marksubsec = ss.ssubsec;
									if (matchsubsec) {
										const uniQsubsecmatch = [...new Set(matchsubsec)];
										uniQsubsecmatch.map((word) => {
											const markreg = new RegExp(word, "g");
											marksubsec = marksubsec.replace(markreg, "<mark>" + word + "</mark>");
										});
									}

									const checkdouble = datarender.every((rend) => {
										return rend.id !== childbase.listobj.id;
									});
									if (checkdouble) {
										datarender.push({ ...JSON.parse(JSON.stringify(childbase.listobj)) });
										datarender[datarender.length - 1].search.sdisplay = { dasechead: childbase.hyperjsontext?.["section-heading"], dasecdesc: childbase.hyperjsontext?.["section-heading-desc"] };
										datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: marksubsec, dasubsechash: ss.ssubsechashid }];
										if (ss.ssubsec.split(" ").length === matchsubsec.length || (ss.ssubsec.split(" ").length > 2 && ss.ssubsec.split(" ").length === matchsubsec.length - 1)) {
											datarender[datarender.length - 1].search.prior += matchsubsec.length * 50;
										} else {
											datarender[datarender.length - 1].search.prior += matchsubsec.length * 5;
										}
									} else {
										// const matchsubsec = ss.ssubsec.match(stokenregex);
										// console.log(matchsubsec, childbase.hyperjsontext["section-heading"]);
										if (Array.isArray(datarender[datarender.length - 1].search.sdisplay.dasubsecarr)) {
											datarender[datarender.length - 1].search.sdisplay.dasubsecarr.push({ dasubsechead: marksubsec, dasubsechash: ss.ssubsechashid });
										} else {
											datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: marksubsec, dasubsechash: ss.ssubsechashid }];
										}
										if (ss.ssubsec.split(" ").length === matchsubsec.length || (ss.ssubsec.split(" ").length > 2 && ss.ssubsec.split(" ").length === matchsubsec.length - 1)) {
											datarender[datarender.length - 1].search.prior += matchsubsec.length * 50;
										} else {
											datarender[datarender.length - 1].search.prior += matchsubsec.length * 10;
										}
									}
								}
								if (Array.isArray(ss.ssubsecdesc) && ss.ssubsecdesc.length && stokenregex.test(ss.ssubsecdesc.join(" "))) {
									const matchsubsecdesc = ss.ssubsecdesc.join(" ").match(stokenregex);
									let marksubsecdesc = ss.ssubsecdesc.join(" ");
									if (matchsubsecdesc) {
										const uniQsubsecdescmatch = [...new Set(matchsubsecdesc)];
										uniQsubsecdescmatch.map((word) => {
											const markreg = new RegExp(word, "g");
											marksubsecdesc = marksubsecdesc.replace(markreg, "<mark>" + word + "</mark>");
										});
									}

									const notdouble = datarender.every((rend) => {
										return rend.id !== childbase.listobj.id;
									});
									if (notdouble) {
										datarender.push({ ...JSON.parse(JSON.stringify(childbase.listobj)) });
										datarender[datarender.length - 1].search.sdisplay = { dasechead: childbase.hyperjsontext?.["section-heading"], dasecdesc: childbase.hyperjsontext?.["section-heading-desc"] };
										datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: ss.ssubsec, dasubsechash: ss.ssubsechashid }];
										const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
										datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [marksubsecdesc];
										datarender[datarender.length - 1].search.prior += matchsubsecdesc.length * 1;
									} else if (Array.isArray(datarender[datarender.length - 1].search.sdisplay.dasubsecarr)) {
										if (Array.isArray(datarender[datarender.length - 1].search.sdisplay.dasubsecarr[datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1]?.dasubsecsteparr)) {
											const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
											datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr.push(marksubsecdesc);
											datarender[datarender.length - 1].search.prior += matchsubsecdesc.length * 1;
										} else {
											const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
											// datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [];
											datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [marksubsecdesc];
											datarender[datarender.length - 1].search.prior += matchsubsecdesc.length * 1;
										}
										// console.log(matchsubsecdesc.length * 1, ss.ssubsec);
									} else {
										datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: ss.ssubsec, dasubsechash: ss.ssubsechashid }];
										// datarender[datarender.length - 1].search.sdisplay.dasubsecarr[datarender[datarender.length - 1].search.sdisplay.dasubsecarr - 1].dasubsecsteparr = [];
										const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
										datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [marksubsecdesc];
										datarender[datarender.length - 1].search.prior += matchsubsecdesc.length * 1;
									}
								}
								if (Array.isArray(ss.ssubsecstepdata) && ss.ssubsecstepdata.length) {
									for (const subsecstepobj of ss.ssubsecstepdata) {
										if (stokenregex.test(subsecstepobj.sstepdata)) {
											const matchstepdata = subsecstepobj.sstepdata.match(stokenregex);
											let markstep = subsecstepobj.sstepdata;
											if (matchstepdata) {
												const uniQstepdatamatch = [...new Set(matchstepdata)];
												uniQstepdatamatch.map((word) => {
													const markreg = new RegExp(word, "g");
													markstep = markstep.replace(markreg, "<mark>" + word + "</mark>");
												});
											}
											const notdouble = datarender.every((rend) => {
												return rend.id !== childbase.listobj.id;
											});
											if (notdouble) {
												// console.log("-- all create", childbase.hyperjsontext?.["section-heading"]);
												datarender.push({ ...JSON.parse(JSON.stringify(childbase.listobj)) });
												datarender[datarender.length - 1].search.sdisplay = { dasechead: childbase.hyperjsontext?.["section-heading"], dasecdesc: childbase.hyperjsontext?.["section-heading-desc"] };
												datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: ss.ssubsec, dasubsechash: ss.ssubsechashid }];
												const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
												datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [markstep];
												datarender[datarender.length - 1].search.prior += matchstepdata.length * 0.2;
											} else if (Array.isArray(datarender[datarender.length - 1].search.sdisplay.dasubsecarr)) {
												if (
													datarender[datarender.length - 1].search.sdisplay.dasubsecarr[datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1].hasOwnProperty("dasubsecsteparr") &&
													Array.isArray(datarender[datarender.length - 1].search.sdisplay.dasubsecarr[datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1].dasubsecsteparr)
												) {
													const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
													datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr.push(markstep);
													datarender[datarender.length - 1].search.prior += matchstepdata.length * 0.2;
													// console.log("-- double direct push", childbase.hyperjsontext?.["section-heading"]);
												} else {
													const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
													// datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [];
													datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [markstep];
													datarender[datarender.length - 1].search.prior += matchstepdata.length * 0.2;
													// console.log("--create step array", childbase.hyperjsontext?.["section-heading"]);
												}
											} else {
												datarender[datarender.length - 1].search.sdisplay.dasubsecarr = [{ dasubsechead: ss.ssubsec, dasubsechash: ss.ssubsechashid }];
												// datarender[datarender.length - 1].search.sdisplay.dasubsecarr[datarender[datarender.length - 1].search.sdisplay.dasubsecarr - 1].dasubsecsteparr = [];
												const lastindex = datarender[datarender.length - 1].search.sdisplay.dasubsecarr.length - 1;
												datarender[datarender.length - 1].search.sdisplay.dasubsecarr[lastindex].dasubsecsteparr = [markstep];
												datarender[datarender.length - 1].search.prior += matchstepdata.length * 0.2;
												console.log("-- subsec array & step array", childbase.hyperjsontext?.["section-heading"]);
											}
										}
									}
								}
							}
						}
					}
				}
			};
			result();
			return new Promise((resolve) => {
				resolve("done");
			});
		};
		await searchbase();
		return new Promise((resolve) => {
			// setloader(false);
			// console.log(datarender);
			datarender.sort((one, two) => {
				if ("search" in one && "prior" in one.search && "search" in two && "prior" in two.search) return one.search.prior < two.search.prior ? 1 : one.search.prior > two.search.prior ? -1 : 0;
			});
			// let returnarray = [datarender, notfoundtoken, realtoken];
			// console.log("--------", datarender, notfoundtoken, realtoken);
			// console.log("-=--=-=-=-=-=-=-==-", datarender);
			resolve(datarender);
		});
	};

	const oos = (searchstring, stoken = "void") => {
		// console.log(mysearch, "has no result");
		fetch("http://localhost:1111/outofsearch", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ oos: searchstring, stoken }),
		})
			.then((response) => response.json())
			// .then((data) => console.log(data))
			.catch((err) => console.log(err, "jck"));
	};

	const sboxnav = (e, listnode) => {
		// console.log(listnode);
		e.stopPropagation();
		if (listnode.status === "deploy") {
			if (listnode["link-transit"]) {
				navigate(`/${listnode["link-transit"]}`);
			} else {
				navigate(`/${listnode.link}?data=${listnode.file}`);
			}
			// console.log("if sbox");
		}
	};

	useMemo(async () => {
		if (mysearch) {
			setloader(true);
			const searchsys = await tokensText(mysearch);
			setExpv(searchsys);
			setloader(false);
			// nftoken = searchsys[1];
			// realtoken = searchsys[2];
			// if (nftoken.length !== 0 && realtoken && nftoken.length !== realtoken.length) {
			// 	// console.log(realtoken, nftoken);
			// 	oos(mysearch, nftoken);
			// }
		}
	}, [mysearch]);

	useEffect(() => {
		// console.log("useEffect navigate");
		if (!mysearch) {
			navigate("/");
			// console.log("navigate block");
		}
		topdiv.current.scrollIntoView({ block: "start" });
	});

	// oos whole string
	// useEffect(() => {
	// 	// console.log("useEffect oos");
	// 	if (expv.length === 0 && mysearch) {
	// 		// oos(mysearch);
	// 	}
	// 	// else if (expv.length > 0 && mysearch) {
	// 	// 	function highlightText(text) {
	// 	// 		// const bodyText = document.body.innerText;
	// 	// 		const rpannel = document.getElementsByClassName("sresbody");
	// 	// 		if (rpannel[0]) {
	// 	// 			const rpannelText = rpannel[0]?.innerHTML;
	// 	// 			// console.log(rpannelText);
	// 	// 			const regex = new RegExp(text, "gi");
	// 	// 			rpannel[0].innerHTML = rpannelText.replace(regex, `<mark>${text}</mark>`);
	// 	// 		}
	// 	// 	}

	// 	// 	// Call the function with the text you want to highlight
	// 	// 	const tokens = mysearch.split(" ");
	// 	// 	for  (let i = 0; i < tokens.length; i++) {
	// 	// 		highlightText(tokens[i]);
	// 	// 	}
	// 	// }
	// }, [expv, mysearch]);

	return (
		<div className="search-body" ref={topdiv}>
			<div className="s-head">
				<h3>Search Result</h3>
				<span className="seprator"></span>
				<p>
					Help file for <span>'{mysearch}'</span>
				</p>
			</div>
			{/* {expv?.length > 11 ? (
				<>
					<div className="myhr"></div>
					<div className="warn">
						<p>search with proper and more keywords for desired result.</p>
					</div>
				</>
			) : null} */}
			<div className="myhr"></div>
			{/* <br /> */}

			{contentLoader && (
				<div className="loader">
					<div className="load1">
						<ContentLoader viewBox="0 0 476 124">
							<rect x="48" y="8" width="88" height="6" rx="3" />
							<rect x="48" y="26" width="52" height="6" rx="3" />
							<rect x="0" y="56" width="410" height="6" rx="3" />
							<rect x="0" y="72" width="380" height="6" rx="3" />
							<rect x="0" y="88" width="178" height="6" rx="3" />
							<circle cx="20" cy="20" r="20" />
						</ContentLoader>
					</div>
					<div className="load1">
						<ContentLoader viewBox="0 0 476 124">
							<rect x="48" y="8" width="88" height="6" rx="3" />
							<rect x="48" y="26" width="52" height="6" rx="3" />
							<rect x="0" y="56" width="410" height="6" rx="3" />
							<rect x="0" y="72" width="380" height="6" rx="3" />
							<rect x="0" y="88" width="178" height="6" rx="3" />
							<circle cx="20" cy="20" r="20" />
						</ContentLoader>
					</div>
				</div>
			)}

			{!contentLoader &&
				(expv?.length > 0 ? (
					<div className="sresbody">
						{expv.map((dataNode, i) => {
							return (
								<section key={i}>
									{dataNode?.nodepath ? (
										<div className="s-result" key={i} onClick={(e) => sboxnav(e, dataNode)}>
											<div /* to={dataNode.status === "deploy" ? `/${dataNode.link}?data=${dataNode.file}&noderoot=${dataNode.id}` : null} */ onClick={() => props.passclick()} clickable={dataNode.status === "deploy" ? "true" : "false"}>
												<h3>{Parser(dataNode.search.sdisplay.dasechead)}</h3>
												<p>
													{dataNode?.search?.sdisplay?.dasecdesc.map((secdesc, i) => {
														return <span key={i}>{Parser(secdesc)}</span>;
													})}
												</p>
												{/* <p>{dataNode.search.prior}</p> */}
											</div>
											<div className="subject">
												{dataNode?.search?.sdisplay?.dasubsecarr &&
													dataNode?.search?.sdisplay?.dasubsecarr.map((subsecobj, i) => {
														return (
															<Link key={i} className="subsectips" to={dataNode.status === "deploy" ? (dataNode["link-transit"] ? `/${dataNode["link-transit"]}#${subsecobj.dasubsechash}` : `/${dataNode.link}?data=${dataNode.file}`) : null} onClick={(e) => e.stopPropagation()}>
																<div className="tipshead">{Parser(subsecobj.dasubsechead)}</div>
																{subsecobj?.dasubsecsteparr &&
																	subsecobj?.dasubsecsteparr.map((stepline, i) => {
																		if (i < 4) {
																			return (
																				<span className="tips" key={i}>
																					{Parser(stepline)}
																				</span>
																			);
																		}
																	})}
															</Link>
														);
													})}
											</div>
										</div>
									) : (
										<div className="s-result" key={i} onClick={(e) => sboxnav(e, dataNode)}>
											<div /* to={dataNode.status === "deploy" ? `/${dataNode.link}?data=${dataNode.file}&noderoot=${dataNode.id}` : null} */ onClick={() => props.passclick()} clickable={dataNode.status === "deploy" ? "true" : "false"}>
												<h3>{Parser(dataNode.name)}</h3>
												<p>{dataNode?.search?.desc && Parser(dataNode?.search?.desc)}</p>
												{/* <p>{dataNode.search.prior}</p> */}
											</div>
											<div className="subject">
												{dataNode?.search?.["sub-section-link"]
													? dataNode.search["sub-section-link"].map((sub, i) => {
															return (
																<Link key={i} className="sublink" to={dataNode.status === "deploy" ? (dataNode["link-transit"] ? `/${dataNode["link-transit"]}#${sub["hash-link"]}` : `/${dataNode.link}?data=${dataNode.file}`) : null} onClick={(e) => e.stopPropagation()}>
																	{sub.name}
																</Link>
															);
													  })
													: null}
											</div>
										</div>
									)}
								</section>
							);
						})}
					</div>
				) : (
					<h1 style={{ color: "darkred" }}>Nothing Found</h1>
				))}
		</div>
	);
});

export default PlusSearch;